import { Box } from '@mui/material'
import { useState } from 'react'
import { MapContainer } from 'react-leaflet'
import MapElements from './MapElements'

const MapLayered = ({
  carbonInstancesByMonitoringPeriod,
  center,
  drawingType,
  eligibilityAreas,
  etapa,
  exclusionAreas,
  handleEtapa,
  handleExclusionAreas,
  handleMapUpdate,
  handleMonitoringSites,
  handleOtherPolygons,
  handleOtherSites,
  handlePaddocks,
  handlePerimeter,
  handleSamplingAreas,
  handleUnassigned,
  handleUnassignedPoints,
  mapHeight,
  mapUpdate,
  mapWidth,
  monitoringSites,
  otherPolygons,
  otherSites,
  paddocks,
  perimeter,
  samplingAreas,
  unassigned,
  unassignedPoints,
}) => {
  const [map, setMap] = useState(null)

  return (
    <Box
      sx={{
        '& .leaflet-container': {
          width: mapWidth,
          height: mapHeight,
        },
      }}
    >
      <MapContainer
        ref={setMap}
        scrollWheelZoom
        zoomControl
        center={center}
        wheelPxPerZoomLevel={60}
        zoom={5}
        zoomDelta={1}
        zoomSnap={0.1}
      >
        <MapElements
          carbonInstancesByMonitoringPeriod={carbonInstancesByMonitoringPeriod}
          center={center}
          drawingType={drawingType}
          eligibilityAreas={eligibilityAreas}
          etapa={etapa}
          exclusionAreas={exclusionAreas}
          handleEtapa={handleEtapa}
          handleExclusionAreas={handleExclusionAreas}
          handleMapUpdate={handleMapUpdate}
          handleMonitoringSites={handleMonitoringSites}
          handleOtherPolygons={handleOtherPolygons}
          handleOtherSites={handleOtherSites}
          handlePaddocks={handlePaddocks}
          handlePerimeter={handlePerimeter}
          handleSamplingAreas={handleSamplingAreas}
          handleUnassigned={handleUnassigned}
          handleUnassignedPoints={handleUnassignedPoints}
          map={map}
          mapUpdate={mapUpdate}
          monitoringSites={monitoringSites}
          otherPolygons={otherPolygons}
          otherSites={otherSites}
          paddocks={paddocks}
          perimeter={perimeter}
          samplingAreas={samplingAreas}
          unassigned={unassigned}
          unassignedPoints={unassignedPoints}
        />
      </MapContainer>
    </Box>
  )
}

export default MapLayered
